import React from 'react';
import moment from 'moment';
import Modal from 'react-modal';

import { SERVER_URL } from '../../../config';
import { formatDisplayDate } from '../../../utils';
import { TRebook } from './types';

type TRebooksAvailabilityModalProps = {
    rebook: TRebook | null;
    onClose: () => void;
};

export const RebooksAvailabilityModal = ({
    rebook,
    onClose,
}: TRebooksAvailabilityModalProps) => {
    const busyBookings = rebook?.busy_bookings ?? [];
    const freeBookings = rebook?.free_bookings ?? [];

    return (
        <Modal
            isOpen={Boolean(rebook)}
            onRequestClose={onClose}
            className="rebooks-availability-modal"
            overlayClassName="rebooks-availability-modal-overlay"
            contentLabel="Rebook availability details"
            ariaHideApp={false}
        >
            {rebook && (
                <div>
                    <div className="popup-header">
                        <div className="popup-header-dismiss" onClick={onClose}>
                            <i className="icon icon-close" />
                        </div>
                        <h1>Availability details</h1>
                    </div>
                    <div className="rebooks-availability-modal-table">
                        <div className="rebooks-availability-source-info">
                            <div className="rebooks-availability-source-title">
                                Source job details
                            </div>
                            <div>
                                <strong>Client:</strong>{' '}
                                {rebook.client.company_name}
                            </div>
                            <div>
                                <strong>Job title:</strong> {rebook.job.title}
                            </div>
                            <div>
                                <strong>Address:</strong> {rebook.job.address1}
                                {rebook.job.city ? `, ${rebook.job.city}` : ''}
                            </div>
                        </div>
                        {busyBookings.length > 0 && (
                            <>
                        <div className="rebooks-availability-modal-title">
                            Blocked extend
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th>Job request</th>
                                    <th>Booking</th>
                                    <th>Date</th>
                                    <th>Day</th>
                                    <th>Blocked by</th>
                                </tr>
                            </thead>
                            <tbody>
                                {busyBookings.map(sourceBooking => (
                                    <tr key={sourceBooking.id}>
                                        <td>
                                            {sourceBooking.job_id &&
                                            sourceBooking.job_reference_number ? (
                                                <a
                                                    className="group-link"
                                                    href={`${SERVER_URL}/job/${sourceBooking.job_id}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {
                                                        sourceBooking.job_reference_number
                                                    }
                                                </a>
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                        <td>
                                            {sourceBooking.reference_number}
                                        </td>
                                        <td>
                                            {sourceBooking.date
                                                ? formatDisplayDate(
                                                      sourceBooking.date,
                                                  )
                                                : '-'}
                                        </td>
                                        <td>
                                            {sourceBooking.date
                                                ? moment(
                                                      sourceBooking.date,
                                                  ).format('dddd')
                                                : '-'}
                                        </td>
                                        <td className="rebooks-blocking-wide-cell">
                                            {(
                                                sourceBooking.blocking_bookings ??
                                                []
                                            ).length === 0 ? (
                                                <span className="rebooks-cell-subtitle">
                                                    No blocking bookings
                                                </span>
                                            ) : (
                                                <div className="rebooks-blocking-list">
                                                    {(
                                                        sourceBooking.blocking_bookings ??
                                                        []
                                                    ).map(blockingBooking => (
                                                        <div
                                                            className="rebooks-blocking-list-item"
                                                            key={
                                                                blockingBooking.id
                                                            }
                                                        >
                                                            <div>
                                                                <strong>
                                                                    Job:
                                                                </strong>{' '}
                                                                <a
                                                                    className="group-link"
                                                                    href={`${SERVER_URL}/job/${blockingBooking.job_id}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    {
                                                                        blockingBooking.job_reference_number
                                                                    }
                                                                </a>{' '}
                                                                -{' '}
                                                                {
                                                                    blockingBooking.job_title
                                                                }
                                                            </div>
                                                            <div>
                                                                <strong>
                                                                    Booking:
                                                                </strong>{' '}
                                                                {
                                                                    blockingBooking.reference_number
                                                                }
                                                            </div>
                                                            <div>
                                                                <strong>
                                                                    Date:
                                                                </strong>{' '}
                                                                {formatDisplayDate(
                                                                    blockingBooking.date,
                                                                )}{' '}
                                                                (
                                                                {moment(
                                                                    blockingBooking.date,
                                                                ).format(
                                                                    'dddd',
                                                                )}
                                                                )
                                                            </div>
                                                            <div>
                                                                <strong>
                                                                    Address:
                                                                </strong>{' '}
                                                                {
                                                                    blockingBooking.job_address
                                                                }
                                                                {blockingBooking.job_city
                                                                    ? `, ${blockingBooking.job_city}`
                                                                    : ''}
                                                            </div>
                                                            <div>
                                                                <strong>
                                                                    Client:
                                                                </strong>{' '}
                                                                {
                                                                    blockingBooking.client_name
                                                                }
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                            </>
                        )}
                    </div>
                    {freeBookings.length > 0 && (
                        <div
                            className={`rebooks-availability-modal-table ${
                                busyBookings.length > 0
                                    ? 'rebooks-availability-modal-table--spaced'
                                    : ''
                            }`}
                        >
                            <div className="rebooks-availability-modal-title">
                                Available extend
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Job request</th>
                                        <th>Booking</th>
                                        <th>Date</th>
                                        <th>Day</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {freeBookings.map(booking => (
                                        <tr key={booking.id}>
                                            <td>
                                                {booking.job_id &&
                                                booking.job_reference_number ? (
                                                    <a
                                                        className="group-link"
                                                        href={`${SERVER_URL}/job/${booking.job_id}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {
                                                            booking.job_reference_number
                                                        }
                                                    </a>
                                                ) : (
                                                    '-'
                                                )}
                                            </td>
                                            <td>{booking.reference_number}</td>
                                            <td>
                                                {booking.date
                                                    ? formatDisplayDate(
                                                          booking.date,
                                                      )
                                                    : '-'}
                                            </td>
                                            <td>
                                                {booking.date
                                                    ? moment(
                                                          booking.date,
                                                      ).format('dddd')
                                                    : '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </Modal>
    );
};
